import React from 'react';
import { DeleteConfirmModal } from '../../components/generic/DeleteConfirmModal';
import { createModal } from '../../components/generic/Modal';
import { useDeleteParticipantEmbeddableFormMutation } from '../../graphql/hooks/useDeleteParticipantEmbeddableFormMutation';
import { useAppContext } from '../../hooks/useAppContext';

interface Props {
  participantId: string;
  participantEmbeddableFormId: string;
  participantEmbeddableFormName: string;
}

export const ParticipantEmbeddableFormDeleteModal = createModal<Props>((props) => {
  const { participantId, participantEmbeddableFormId, participantEmbeddableFormName, modal } =
    props;
  const { organization, successToast, errorToast } = useAppContext();

  const mutation = useDeleteParticipantEmbeddableFormMutation();

  const onDelete = React.useCallback(async () => {
    await mutation
      .mutateAsync({
        organizationId: organization.id,
        participantId,
        participantEmbeddableFormId,
      })
      .then(async () => {
        successToast('Embeddable form deleted successfully');
      })
      .catch((err) => {
        errorToast(`Error deleting embeddable form: ${err.message}`);
      });
  }, [
    mutation,
    organization.id,
    participantId,
    participantEmbeddableFormId,
    successToast,
    errorToast,
  ]);

  return (
    <DeleteConfirmModal
      modal={modal}
      heading='Do you want to delete this embeddable form?'
      confirmation={{ level: 'Level2', confirm: participantEmbeddableFormName }}
      onDelete={onDelete}
      isLoading={mutation.isLoading}
    />
  );
});
